import axios from 'axios';
import { getHostname } from './server/server'

const hostname = getHostname();
const path = '/v2/formAnswer';

async function saveFormAnswer(answerPayload) {
    const res = await axios.post(`${hostname}${path}/`, {answer: answerPayload});
    return res.data;
}

export {
    saveFormAnswer
}